import {
  Box,
  Chip,
  Grid,
  ListItem,
  Typography,
  useMediaQuery,
} from "@mui/material";
import theme from "../../styles/styleTheme";
import { Link } from "react-router-dom";
import { PropertyImage } from "../PropertyOverview/PropertyCard";
import StraightenIcon from "@mui/icons-material/Straighten";
import BedOutlinedIcon from "@mui/icons-material/BedOutlined";
import NAV from "../../utils/nav.const";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../utils/currency";
import { BoxPaper } from "../common/BoxPaper";

interface ComplexSidebarProps {
  properties: any;
}

const ComplexProperties = ({ properties }: ComplexSidebarProps) => {
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();

  return (
    <>
      {properties?.length > 0 && (
        <BoxPaper
          style={{
            marginTop: "24px",
            padding: ".5rem 1rem",
          }}
        >
          <>
            {properties?.map((property: any, index: number) => (
              <ListItem
                dense
                disablePadding
                sx={{
                  padding: ".5rem 0",
                  borderTop:
                    index !== 0
                      ? "1px solid " + theme.palette.primary.light
                      : null,
                  color: "#000",
                  fontSize: "1rem",
                }}
                key={property.id}
                component={Link}
                to={`/${NAV.PROPERTY_DETAILS}/${property?.urlSlug}`}
              >
                <Grid container spacing={2}>
                  <Grid item xs={isSmallScreen ? 12 : 0}>
                    <Box
                      position={"relative"}
                      marginRight={2}
                      height={"100%"}
                      width={"100%"}
                    >
                      <PropertyImage
                        width={isSmallScreen ? "100%" : "10rem"}
                        src={
                          property.imageUrl !== ""
                            ? property.imageUrl
                            : require("../../assets/images/no-image.jpg")
                        }
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm container>
                    <Grid item xs container direction="column" spacing={2}>
                      <Grid item xs>
                        <Typography
                          variant="h4"
                          sx={{
                            textDecoration: "none",
                            color: "#333",
                            marginBottom: ".5rem",
                          }}
                        >
                          {property?.title}
                        </Typography>
                        {isSmallScreen && (
                          <Typography
                            variant="h5"
                            sx={{
                              textDecoration: "none",
                              color: "#333",
                              marginBottom: ".5rem",
                            }}
                          >
                            {property?.type?.name === "Collection" &&
                              property?.propertyCollectionDetails?.minPrice >
                                0 &&
                              property?.propertyCollectionDetails?.maxPrice >
                                0 && (
                                <>
                                  {formatCurrency(
                                    property?.propertyCollectionDetails
                                      ?.minPrice
                                  )}{" "}
                                  -{" "}
                                  {formatCurrency(
                                    property?.propertyCollectionDetails
                                      ?.maxPrice
                                  )}
                                </>
                              )}
                          </Typography>
                        )}
                      </Grid>
                      <Grid
                        item
                        display={"flex"}
                        gap={1}
                        sx={{
                          flexWrap: isSmallScreen ? "wrap" : "no-wrap",
                        }}
                      >
                        {(property?.noOfRoomsMin || property?.noOfRooms) && (
                          <>
                            <Chip
                              size={isSmallScreen ? "small" : "medium"}
                              icon={
                                <StraightenIcon
                                  style={{ color: theme.palette.primary.main }}
                                />
                              }
                              sx={{
                                fontSize: ".8em",
                                color: theme.palette.primary.main,
                                borderColor: theme.palette.primary.main,
                                backgroundColor: theme.palette.primary.light,
                                marginRight: ".5rem",
                              }}
                              label={
                                <Box>
                                  {property?.type?.name === "Collection" && (
                                    <>
                                      {property?.livingAreaMin} -{" "}
                                      {property?.livingAreaMax} m²
                                    </>
                                  )}
                                  {property?.type?.name === "Property" && (
                                    <>{property?.livingArea} m²</>
                                  )}
                                </Box>
                              }
                            />
                          </>
                        )}
                        {(property?.noOfRoomsMin || property?.noOfRooms) && (
                          <>
                            <Chip
                              size={isSmallScreen ? "small" : "medium"}
                              icon={
                                <BedOutlinedIcon
                                  style={{ color: theme.palette.primary.main }}
                                />
                              }
                              sx={{
                                fontSize: ".8em",
                                color: theme.palette.primary.main,
                                borderColor: theme.palette.primary.main,
                                backgroundColor: theme.palette.primary.light,
                              }}
                              label={
                                <Box>
                                  {property?.type?.name === "Collection" && (
                                    <>
                                      {property?.noOfRoomsMin} -{" "}
                                      {property?.noOfRoomsMax} kamers
                                    </>
                                  )}
                                  {property?.type?.name === "Property" && (
                                    <>{property?.noOfRooms} m²</>
                                  )}
                                </Box>
                              }
                            />
                          </>
                        )}
                      </Grid>
                    </Grid>
                    {!isSmallScreen && (
                      <Grid
                        marginLeft={isSmallScreen ? 2 : 0}
                        marginRight={2}
                        item
                      >
                        <Typography variant="h5">
                          {property?.type?.name === "Collection" &&
                            property?.propertyCollectionDetails?.minPrice > 0 &&
                            property?.propertyCollectionDetails?.maxPrice >
                              0 && (
                              <>
                                {formatCurrency(
                                  property?.propertyCollectionDetails?.minPrice
                                )}{" "}
                                -
                                {formatCurrency(
                                  property?.propertyCollectionDetails?.maxPrice
                                )}
                              </>
                            )}
                          {property?.type?.name === "Collection" &&
                            (!property?.propertyCollectionDetails?.minPrice ||
                              !property?.propertyCollectionDetails
                                ?.maxPrice) && (
                              <>
                                {formatCurrency(
                                  property?.propertyDetails?.minimumRent
                                )}
                              </>
                            )}
                          {property?.type?.name === "Property" && (
                            <>
                              {formatCurrency(
                                property?.propertyDetails?.minimumRent
                              )}
                            </>
                          )}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </ListItem>
            ))}
          </>
        </BoxPaper>
      )}
    </>
  );
};

export default ComplexProperties;
